/**
 * Global imports
 */
import svg4everybody from 'svg4everybody';
import MobileMenu from './components/mobile-menu';
import singleProductSwiper from './components/singleProductSwiper';
import sale from './blocks/sale';
import productSlider from './blocks/productSlider';
import productArchive from './blocks/productArchive';
import hero from './blocks/hero';
import gallery from './blocks/gallery';
import video from './blocks/video';
import specifications from './components/specifications';
import productColorVariants from './components/productColorVariants';
import prices from './blocks/prices';
import TagNav from './components/tagNav';
import HeaderSearch from './components/headerSearch';
import { initShop } from './shop/index';
import NotificationBar from './components/notification-bar';
import contactMap from './blocks/contactMap';
import prodajnaMjesta from './blocks/prodajnaMjesta';
import PromoModal from './components/promo-modal';
import accordionGroups from './components/accordion-groups';
import MegaMenu from './components/mega-menu';
import vijestiArchive from './blocks/vijestiArchive';
import vijestiSingle from './blocks/vijestiSingle';
import gformUploadI18n from './components/gform-upload-i18n';
import anchorSections from './components/anchor-sections';

document.addEventListener('DOMContentLoaded', () => {
	svg4everybody();
	MobileMenu();
	singleProductSwiper();
	sale();
	productSlider();
	if (document.querySelector('.product-archive')) {
		productArchive();
	}
	if (document.querySelector('.hero')) {
		hero();
	}

	if (document.querySelector('.gallery')) {
		gallery();
	}

	if (document.querySelector('.video')) {
		video();
	}

	specifications();
	prices();
	productColorVariants();
	TagNav();
	HeaderSearch();
	initShop();
	NotificationBar();
	contactMap();
	prodajnaMjesta();
	PromoModal();
	MegaMenu();

	if (document.querySelector('.accordion-groups')) {
		accordionGroups();
	}

	if (document.querySelector('.vijesti-archive')) {
		vijestiArchive();
	}

	if (document.querySelector('.vijesti-single')) {
		vijestiSingle();
	}

	if (document.querySelector('.inquiry-form')) {
		gformUploadI18n();
	}

	if (document.querySelector('.anchor-sections')) {
		anchorSections();
	}
});
